import React from 'react';
import YeastNutrientimg from '../../assets/images/YeastNutrients.png'
import './YeastNutrients.css'
import { useTranslation } from 'react-i18next';

function YeastNutrients() {
  const { t } = useTranslation();

  const products = [
   
    {
        name: t('ICEferm SC'),
        description: t('Preparation of selected and purified yeast hulls.The synergy between ethanol and toxic substances produced by yeast metabolism is one of the major causes of stuck fermentation. It is a product with particular aptitudes for adsorbing and eliminating these toxic substances, ensuring the smooth progress of fermentation.'),
      },
      {
        name: t('ICEferm XR'),
        description: t('Activator, specific fermentation supplement for quality red wines. It is a complex organic nutrient based on specially selected peels, containing assimilable nitrogen in the form of amino acids and yeast oligopeptides, growth and survival factors.'),
      },
      {
        name: t('ICEferm XB'),
        description: t('Activator, specific fermentation supplement for quality white wines. It is a complex organic nutrient based on specially selected peels, containing assimilable nitrogen in the form of amino acids and yeast oligopeptides, growth and survival factors and glutathione.'),
      },
      {
        name: t('ICEferm XP'),
        description: t('ICEferm XP is a preparation made up of a specific inactivated yeast rich in a tripeptide with a protective action, supported by a very delicate, but at the same time very reactive, exotic tannin which limits the risks of loss of aromatic compounds sensitive to oxidation.'),
      },
      {
        name: t('ICEferm CLASSIC K'),
        description: t('Fermentation regulator composed of preparations based on yeast derivatives, ammonium phosphate, thiamine (vit. B1), appropriately mixed for fermentation regularity and resistance in the critical fermentation phases.'),
      },
      {
        name: t('ICEferm PLUS'),
        description: t('Complex nutrient, fermentation regulator specifically designed to provide the yeast with the macro and micro-nutrients it needs in the different stages of development. Composition: preparations of yeast hulls, dibasic ammonium phosphate, ammonium sulphate and thiamine.Recommended to promote the regularity of fermentation and the resistance of the yeast in the most critical phases.'),
      },
      {
        name: t('ICEferm START'),
        description: t('Organic nourishment naturally rich in amino acids and vitamins, fermentation regulator for quality wines.In the early stages of fermentation, when the toxic action of ethanol is still low, it allows for the best development of all the characteristics of the yeast, thanks to the supply of nitrogen in organic form. To integrate readily assimilable nitrogen, we recommend the use of ICEferm Plus or ICEferm Classic.'),
      },
     
  
  ];

  return (
  <>
   <div className='mainYeastNImg'>
  <div className='YeastNImg1'></div>

  <div className="YeastNImg2">
    <h1 className="YeastNTitle">{t("Yeast Nutrients")}</h1>
    <img src={YeastNutrientimg} alt="Yeast Nutrients" className="YeastNImage" />
  </div>
</div>
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default YeastNutrients;
